import { Cess } from "./cess";
import { Tax } from "./tax";

export class ViewOfferSetUpDto {
    schemeName: string;
    schemeType: string;
    offerId: string;
    productCode: number;
    productName: string;
    netSalePrice: number;
    maxQtyPerBill: number;
    minQty: number;
    toTime: string;
    checked: boolean;

    productPriceForCustomer: number;
    productPriceForLocation: number;
    foodType: string;
    productPicture: string;
    getProductCode: number;
    getProductName: string;
    subGroupCode: number;
    hsnCode: string;
    maxDiscountPercentage: number;
    getFoodType: string;
    getProductPicture: string;
    fromTime: string;
    discPercent: number;
    discValue: number;
    fromValue: number;
    toValue: number;
    cessRateCode: number;
    taxRateCode: number;
    buyQty: number;
    getQty: number;
    cess: Cess;
    tax: Tax;
}